module.exports = __webpack_public_path__ + "img/Special_1.dc6e4c80.jpeg";